import {RouteInfo} from './sidebar.metadata';

// @ts-ignore
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard/dashboardoperation',
    title: '',
    icon: 'mdi mdi-chart-pie',
    url: 'assets/images/menu/pie-chart.svg',
    urlhover: 'assets/images/menu/pie-chart_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1,
  },
  {
    path: '/dashboard/dashboardoperation',
    title: '',
    icon: 'mdi mdi-chart-pie',
    url: 'assets/images/menu/pie-chart.svg',
    urlhover: 'assets/images/menu/pie-chart_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 2,
  },
  {
    path: '/dashboard/dashboardoperationpublic',
    title: '',
    icon: 'mdi mdi-chart-pie',
    url: 'assets/images/menu/pie-chart.svg',
    urlhover: 'assets/images/menu/pie-chart_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 20,
  }, {
    path: '/dashboard/brouillon',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/layer.svg',
    urlhover: 'assets/images/menu/layer_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1,
  }, {
    path: '/dashboard/studies',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/layer.svg',
    urlhover: 'assets/images/menu/layer_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 2,
  }, {
    path: '/dashboard/studies',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/layer.svg',
    urlhover: 'assets/images/menu/layer_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 20,
  }, {
    path: '/dashboard/etude/market',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/market.svg',
    urlhover: 'assets/images/menu/market_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 2,
  }, {
    path: '/dashboard/etude/market',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/market.svg',
    urlhover: 'assets/images/menu/market_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 20,
  }, {
    path: '/dashboard/etude/market',
    title: '',
    icon: 'mdi mdi-layers',
    url: 'assets/images/menu/market.svg',
    urlhover: 'assets/images/menu/market_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1,
  }, {
    path: '/dashboard/etude/whiteboards',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/rapport.svg',
    urlhover: 'assets/images/menu/rapport_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1
  },
  {
    path: '/dashboard/etude/whiteboards',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/rapport.svg',
    urlhover: 'assets/images/menu/rapport_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 2
  },
  {
    path: '/dashboard/etude/whiteboards',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/rapport.svg',
    urlhover: 'assets/images/menu/rapport_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 20
  },
  {
    path: '/dashboard/consent-forms',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/iconConsentForm.svg',
    urlhover: 'assets/images/menu/iconConsentFormOver.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 20
  },
 {
    path: '/dashboard/consent-forms',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/iconConsentForm.svg',
    urlhover: 'assets/images/menu/iconConsentFormOver.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 2
  },
  {
    path: '/dashboard/all-consent-form',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/iconConsentForm.svg',
    urlhover: 'assets/images/menu/iconConsentFormOver.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1
  },
  {
    path: '/dashboard/all-administration',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/toolbox.svg',
    urlhover: 'assets/images/menu/toolbox_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1
  },
  {
    path: '/dashboard/datahub',
    title: '',
    icon: 'mdi mdi-database',
    url: 'assets/images/menu/datahub.svg',
    urlhover: 'assets/images/menu/datahub_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1
  },
  {
    path: '/dashboard/admin-user',
    title: '',
    icon: 'mdi mdi-briefcase',
    url: 'assets/images/menu/user_admin.svg',
    urlhover: 'assets/images/menu/user_admin_hover.svg',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    profile: 1
  },
];
